module.exports = __webpack_public_path__ + "media/images/backgrounds/create_new-c981321cd892f22d199d437028a8cfed.png";